module.exports = __webpack_public_path__ + "img/thumb-reef-cruises.a0ca5aaa.jpg";